import React from "react";
import styles from "./sidebar.scss";

import { Header } from "../header/header";
import { TourContent } from "../tour/tourContent";
import { TourList } from "../tour/tourList";

import { FiltersContent } from "../filters/filtersContent";
import { FiltersHeader } from "../filters/filtersHeader";
import { FilterGroups } from "../filter/filterGroups";
import { useRecoilValue } from "recoil";
import { filtersState } from "../../common/recoil-atoms";
import { useQueryParams } from "../../common/hooks";
import { useHistory } from "react-router-dom";
import queryString from "query-string";
import { Constants } from "../../common/constants";

const traverseFilters = (items) => {
    for (let item of items) {
        if (item.items) {
            traverseFilters(items);
        }
    }
};

const getAllCheckedItemsFlattened = (items) => {
    var result = [];
    for (let item of items) {
        if (item.checked) result.push(item);
        if (item.items) {
            var tmp = getAllCheckedItemsFlattened(item.items);
            result = result.concat(tmp);
        }
    }

    return result;
};

const Sidebar = ({
    tours,
    currentTour,
    loading,
    searching,
    searchResults,
    navOpen,
    mapOpen,
    searchOpen,
    filtersNavOpen,
    onSelectTour,
    onNavOpen,
    onNavClose,
    onSearchOpen,
    onSearchClose,
    onFiltersNavOpen,
    onMapOpen,
    onSearching,
}) => {
    var filtersData = useRecoilValue(filtersState);
    var queryParams = useQueryParams();
    var history = useHistory();

    const handleSearch = (e) => {
        // flatten array of filters and filter checked ones
        var checkedFilterItems = getAllCheckedItemsFlattened(filtersData);

        // get al different types
        var types = checkedFilterItems
            .map((x) => x.type)
            .filter((value, index, self) => self.indexOf(value) === index);

        // compose URL params for every type
        for (let type of types) {
            var ids = checkedFilterItems.filter((x) => x.type === type).map((x) => x.id);
            queryParams[type] = ids.join(Constants.FilterSplitChar);
        }
        history.push("?" + queryString.stringify(queryParams));

        onFiltersNavOpen();
    };

    return (
        <div className={styles.sidebar}>
            <Header
                onNavOpen={onNavOpen}
                onNavClose={onNavClose}
                onSearchOpen={onSearchOpen}
                onSearchClose={onSearchClose}
                onMapOpen={onMapOpen}
                navOpen={navOpen}
                searchResults={searchResults}
                searchOpen={searchOpen}
                searching={searching}
                onSearching={onSearching}
            />
            <FiltersHeader
                tours={tours}
                filtersNavOpen={filtersNavOpen}
                onFiltersNavOpen={onFiltersNavOpen}
            />
            <div className={styles.content}>
                <TourContent tours={tours} loading={loading} mapOpen={mapOpen}>
                    <TourList onSelectTour={onSelectTour} tours={tours} currentTour={currentTour} />
                    <button className={styles.showMap} onClick={onMapOpen}>
                        {window.tstrings["Bekijk op kaart"]}
                    </button>
                </TourContent>

                {/* Only show when filters are open */}
                <FiltersContent filtersNavOpen={filtersNavOpen}>
                    <FilterGroups></FilterGroups>

                    <div className={styles.applyFilters} onClick={handleSearch}>
                        <button>{window.tstrings["Toepassen"]}</button>
                    </div>
                </FiltersContent>
            </div>
        </div>
    );
};

export { Sidebar };
